import { useActiveOrganization, useIsOrgOwner } from "@/hooks/organizations";
import { useWorkspaceInvites } from "@/queries/workspace-invites";
import { Clock4, UserIcon } from "lucide-react";
import moment from "moment";

import {
  Container,
  Item,
  ItemAction,
  ItemContent,
  ItemDescription,
  ItemIcon,
  ItemTitle,
} from "../../components/Container";
import {
  Section,
  SectionHeader,
  SectionItem,
  SectionTitle,
} from "../../components/Section";
import DeleteInvite from "./DeleteInvite";

const PendingInvites = () => {
  const activeOrganization = useActiveOrganization();
  const isOrgOwner = useIsOrgOwner();
  const workspaceInvites = useWorkspaceInvites({
    organization_id: activeOrganization?.id,
  });
  const pendingInvites = workspaceInvites.data?.items || [];

  if (pendingInvites.length === 0) return null;

  return (
    <Section>
      <SectionItem>
        <SectionHeader>
          <SectionTitle>Pending Invites</SectionTitle>
        </SectionHeader>
      </SectionItem>
      <SectionItem>
        <Container>
          {pendingInvites.map((invite) => (
            <Item key={invite.id}>
              <ItemContent>
                <ItemIcon>
                  <UserIcon />
                </ItemIcon>
                <div className="flex flex-col">
                  <ItemTitle>{invite.invitee_email}</ItemTitle>
                  <ItemDescription className="flex items-center">
                    <Clock4 className="h-4" />
                    expires {moment.utc(invite.expires_at).fromNow()}
                  </ItemDescription>
                </div>
              </ItemContent>
              <ItemAction>
                {isOrgOwner && <DeleteInvite invite={invite} />}
              </ItemAction>
            </Item>
          ))}
        </Container>
      </SectionItem>
    </Section>
  );
};

export default PendingInvites;
